import { useCallback } from 'react';
import { addError } from '../../../store/Error';
import { useSnackbar } from '../../../Context/SnackbarContext';

/** Shows a refused save in the snackbar, in the words given, and records it with the engagement's errors. */
export const useShowRefusal = () => {
  const { setSnack } = useSnackbar();
  return useCallback(
    (message: string) => {
      addError('advise-engagement', message);
      setSnack({ message, open: true, type: 'error' });
    },
    [setSnack]
  );
};
